import { useSyncExternalStore } from 'react';
import { getAccessToken, subscribeSession } from './session';

/** True while an access token is held. */
export function useSignedIn(): boolean {
  return useSyncExternalStore(
    subscribeSession,
    () => getAccessToken() !== null,
  );
}
